import React from 'react';
import { Link } from 'react-router-dom';
const services = [{
  label: 'Mobile Detailing',
  to: '/services/mobile-detailing'
}, {
  label: 'Interior Detailing',
  to: '/services/interior-detailing'
}, {
  label: 'Exterior Detailing',
  to: '/services/exterior-detailing'
}, {
  label: 'Full Car Detail',
  to: '/full-detail'
}, {
  label: 'Engine Bay Detailing',
  to: '/services/engine-bay-detailing'
}, {
  label: 'Headlight Restoration',
  to: '/services/headlight-restoration'
}, {
  label: 'Hybrid Ceramic Spray',
  to: '/services/hybrid-ceramic-spray'
}];
const citiesList = [{
  label: 'Camarillo',
  to: '/mobile-detailing-camarillo'
}, {
  label: 'Oxnard',
  to: '/mobile-detailing-oxnard'
}, {
  label: 'Ventura',
  to: '/mobile-detailing-ventura'
}, {
  label: 'Thousand Oaks',
  to: '/mobile-detailing-thousand-oaks'
}, {
  label: 'Simi Valley',
  to: '/mobile-detailing-simi-valley'
}, {
  label: 'Moorpark',
  to: '/mobile-detailing-moorpark'
}, {
  label: 'Newbury Park',
  to: '/mobile-detailing-newbury-park'
}, {
  label: 'Westlake Village',
  to: '/mobile-detailing-westlake-village'
}];
export function SeoContent() {
  return <section className="w-full bg-black py-16 px-4 border-t border-zinc-900" aria-labelledby="seo-content-heading" data-id="element-324" data-mp="3i2ma31v30chc">
      <div className="max-w-4xl mx-auto" data-id="element-325" data-mp="3mzmivkjbftc5">
        <div className="prose prose-invert prose-lg max-w-none prose-headings:font-black prose-headings:uppercase prose-headings:tracking-tight prose-h2:text-3xl md:prose-h2:text-4xl prose-h2:mb-5 prose-h2:mt-12 first:prose-h2:mt-0 prose-h3:text-xl prose-h3:text-yellow-400 prose-p:text-gray-300 prose-p:leading-relaxed prose-li:text-gray-300 prose-strong:text-white prose-a:text-red-500 hover:prose-a:underline" data-id="element-326" data-mp="3rsfkhzjhmlk0">
          <h2 id="seo-content-heading" data-id="element-327" data-mp="ekcl2omglaa6">
            Mobile Detailing in Ventura County, Done Right
          </h2>
          <p data-id="element-328" data-mp="2bfh2nd02sinz">
            <strong data-id="element-329" data-mp="2bg0lqx1gpd3l">Mike's Pro Detail</strong> is a premium{' '}
            <strong data-id="element-330" data-mp="2ge25zlamjign">mobile car detailing</strong> company proudly serving{' '}
            <strong data-id="element-331" data-mp="3jnekrpakbrbw">Ventura County, California</strong>. We bring a fully
            equipped, professional detail shop directly to your driveway, so you
            get a flawless, showroom-quality finish without ever leaving home.
            From{' '}
            <Link to="/mobile-detailing-camarillo" data-id="element-332" data-mp="3smi32r1wo2pc">
              mobile detailing in Camarillo
            </Link>{' '}
            and{' '}
            <Link to="/mobile-detailing-oxnard" data-id="element-333" data-mp="6guwxro8w2xi">car detailing in Oxnard</Link> to{' '}
            <Link to="/mobile-detailing-ventura" data-id="element-334" data-mp="1ijo9k9orygv">auto detailing in Ventura</Link>
            ,
            our mobile team comes to you with our own water, detailing
            equipment, and premium eco-friendly products. There is no
            drop-off, no waiting room, and no compromise on quality.
          </p>
          <p data-id="element-335" data-mp="p72xq34h2haj">
            Whether you searched for <em data-id="element-336" data-mp="p85nu8tz0fpe">"car detailing near me"</em>,{' '}
            <em data-id="element-337" data-mp="k9b67a7qox6v">"mobile car detailing Ventura County"</em>, or a specific
            service in your city, you have found the most trusted name in local
            auto detailing. We treat every vehicle as if it were our own,
            combining meticulous hand work with professional-grade equipment to
            deliver results that protect your investment and turn heads.
          </p>

          <h2 data-id="element-338" data-mp="yv8ai2cb3eni">Why Choose Mobile Detailing?</h2>
          <p data-id="element-339" data-mp="ytx4rwzavwtr">
            Traditional car washes are fast but harsh — automated brushes and
            recycled water can leave swirl marks and scratches in your clear
            coat. Professional mobile detailing is the opposite: a careful,
            hand-crafted process performed right where you live or work.
            Choosing{' '}
            <Link to="/services/mobile-detailing" data-id="element-340" data-mp="g4qt2twxc5hg">
              mobile detailing in Ventura County
            </Link>{' '}
            gives you several major advantages:
          </p>
          <ul data-id="element-341" data-mp="27licgm9mifv">
            <li data-id="element-342" data-mp="66kryeixz3dn">
              <strong data-id="element-343" data-mp="672nf8xs5dki">Convenience:</strong> We come to your home, office, or
              apartment. You reclaim hours of your day instead of sitting at a
              shop.
            </li>
            <li data-id="element-344" data-mp="3q9e1nm059koi">
              <strong data-id="element-345" data-mp="3qayw7bmgl3md">Quality:</strong> Hand washing, clay bar decontamination,
              and careful interior work that automated washes simply cannot
              match.
            </li>
            <li data-id="element-346" data-mp="3gkw0v4rv7dkv">
              <strong data-id="element-347" data-mp="3gjcnblxlfgms">We bring the equipment:</strong> We bring our own water
              and detailing equipment. We require access to a standard
              electrical outlet at the service location.
            </li>
            <li data-id="element-348" data-mp="37i4rrbmgotwe">
              <strong data-id="element-349" data-mp="37lsgzykviu5b">Protection:</strong> Premium waxes, sealants, and ceramic
              coatings that shield your paint from the Southern California sun
              and coastal salt air.
            </li>
          </ul>

          <h2 data-id="element-350" data-mp="10thyla8ucge3">Our Professional Detailing Services</h2>
          <p data-id="element-351" data-mp="10s6u187kn4lx">
            We offer a complete range of mobile detailing services for cars,
            trucks, and SUVs across Ventura County. Each service is performed
            on-site and tailored to your vehicle's specific needs.
          </p>

          <h3 data-id="element-352" data-mp="18bpm03ysm86n">Interior Detailing</h3>
          <p data-id="element-353" data-mp="18axxte7izcqe">
            Our{' '}
            <Link to="/services/interior-detailing" data-id="element-354" data-mp="1d37kmldcfwog">interior detailing</Link>{' '}
            service deep cleans, shampoos, steam sanitizes, and conditions every
            surface inside your cabin. We remove embedded dirt, pet hair,
            stains, and odors, restoring a fresh, like-new feel while improving
            the air quality you breathe on every drive.
          </p>

          <h3 data-id="element-355" data-mp="pfg9vm7gbrpa">Exterior Detailing</h3>
          <p data-id="element-356" data-mp="ucgh40g1f0hz">
            Our{' '}
            <Link to="/services/exterior-detailing" data-id="element-357" data-mp="ub55jegcoogb">exterior detailing</Link>{' '}
            service includes a safe hand wash, clay bar treatment, wheel and
            tire cleaning, and a durable wax or sealant. This safely removes
            bonded contaminants, restores deep gloss, and protects your paint
            from UV damage and oxidation.
          </p>

          <h3 data-id="element-358" data-mp="1l1sucm8jnb4r">Full Car Detail</h3>
          <p data-id="element-359" data-mp="1l0zlnfq0ybjz">
            Our most popular package, the{' '}
            <Link to="/full-detail" data-id="element-360" data-mp="1g4izgr2dy79j">full car detail</Link>,
            combines our complete interior and exterior services for a true
            bumper-to-bumper transformation. It is the most cost-effective way
            to completely reset your vehicle's condition inside and out.
          </p>

          <h3 data-id="element-361" data-mp="12de4i29yq35j">Engine Bay Detailing</h3>
          <p data-id="element-362" data-mp="12a8emktiex8r">
            Our{' '}
            <Link to="/services/engine-bay-detailing" data-id="element-363" data-mp="xdi041xcs9pg">
              engine bay detailing
            </Link>{' '}
            safely degreases and cleans your engine compartment, making it
            easier to spot leaks, helping prevent heat-trapping grime, and
            dramatically improving your vehicle's presentation and resale value.
          </p>

          <h3 data-id="element-364" data-mp="jk0iwns5392l">Headlight Restoration</h3>
          <p data-id="element-365" data-mp="en0cucvai6bh">
            Cloudy, yellowed headlights are both an eyesore and a safety hazard.
            Our{' '}
            <Link to="/services/headlight-restoration" data-id="element-366" data-mp="2q9tyhh4ahto3">
              headlight restoration
            </Link>{' '}
            service permanently removes oxidation and restores crystal-clear
            lenses, improving your nighttime visibility and your car's
            appearance.
          </p>

          <h3 data-id="element-367" data-mp="2la8yr4haphab">Hybrid Ceramic Spray Protection</h3>
          <p data-id="element-368" data-mp="2l8o6jligeafm">
            Our{' '}
            <Link to="/services/hybrid-ceramic-spray" data-id="element-369" data-mp="3903fvy8nds0d">
              hybrid ceramic spray protection
            </Link>{' '}
            is sprayed on by hand at the end of a detail, adding gloss and
            helping your paint shed water and dirt. It is included in our Wash
            &amp; Wax and Full Detail packages.
          </p>

          <h2 data-id="element-370" data-mp="33zxjk4rfnhby">Serving All of Ventura County</h2>
          <p data-id="element-371" data-mp="1ol03maqyqogn">
            As a mobile operation, we bring our detailing service to every
            community in Ventura County. Wherever you are, we come to you with a
            complete, professional detail. Explore our dedicated city pages for
            local information and pricing:
          </p>
          <div className="not-prose grid grid-cols-2 sm:grid-cols-4 gap-3 my-8" data-id="element-372" data-mp="2fabprem8ps26">
            {citiesList.map(c => <Link key={c.to} to={c.to} className="block text-center px-3 py-3 bg-zinc-900/60 border border-zinc-800 rounded-lg text-white font-bold text-sm hover:border-red-900/60 hover:bg-zinc-800/60 transition-all" data-id="element-373" data-mp="2b8gebhalhyao">
                {c.label}
              </Link>)}
          </div>
          <p data-id="element-374" data-mp="2yz2n5asfbmlq">
            We provide{' '}
            <Link to="/mobile-detailing-camarillo" data-id="element-375" data-mp="2z03xfd1m852e">
              mobile detailing in Camarillo
            </Link>
            ,{' '}
            <Link to="/mobile-detailing-oxnard" data-id="element-376" data-mp="2u5rc0xgkwjo0">car detailing in Oxnard</Link>,{' '}
            <Link to="/mobile-detailing-ventura" data-id="element-377" data-mp="2p8r8at77bt02">auto detailing in Ventura</Link>
            ,{' '}
            <Link to="/mobile-detailing-thousand-oaks" data-id="element-378" data-mp="3mppzq9dab0em">
              detailing in Thousand Oaks
            </Link>
            , <Link to="/mobile-detailing-simi-valley" data-id="element-379" data-mp="3hvu0z4p759ie">Simi Valley</Link>,{' '}
            <Link to="/mobile-detailing-moorpark" data-id="element-380" data-mp="3panulekjw0f4">Moorpark</Link>,{' '}
            <Link to="/mobile-detailing-newbury-park" data-id="element-381" data-mp="3u8z57rio6eye">Newbury Park</Link>, and{' '}
            <Link to="/mobile-detailing-westlake-village" data-id="element-382" data-mp="31d86hqghaqi">
              Westlake Village
            </Link>
            .
          </p>

          <h2 data-id="element-383" data-mp="74rlv1qx9f0s">Why Ventura County Trusts Mike's Pro Detail</h2>
          <p data-id="element-384" data-mp="c32zzoo92bot">
            With a 5-star reputation built across Ventura County, Full Detail
            Pro has earned the loyalty of drivers who demand the very best for
            their vehicles. Our success comes down to a simple philosophy:
            uncompromising quality, genuine convenience, and treating every
            customer's car with the same care we would give our own. We use only
            premium, eco-friendly products and professional-grade equipment, and
            we never rush a job — because a truly great detail takes time and
            attention.
          </p>
          <p data-id="element-385" data-mp="22r8t6z55qzex">
            Our experienced technicians understand the unique challenges of
            Southern California vehicles: relentless UV exposure that fades
            paint and cracks interiors, coastal salt air that accelerates
            corrosion, and fine inland dust that works its way into every
            surface. Every service we provide is designed to combat these
            conditions and keep your vehicle protected, beautiful, and holding
            its value for years to come.
          </p>

          <h2 data-id="element-386" data-mp="2qeqmiz42m5k0">How Our Mobile Detailing Process Works</h2>
          <p data-id="element-387" data-mp="2vfefhqbv0wgv">
            Booking is simple. Call or text Mike directly, describe your vehicle
            and the service you need, and we will provide a clear quote and find
            a time that works for you — including weekends. On the day of your
            appointment, our fully equipped mobile unit arrives at your home or
            office with everything required to complete the detail on-site. You
            stay productive or relax while we transform your vehicle, and you
            inspect the results before we leave. It is professional auto
            detailing made effortless.
          </p>

          <h2 data-id="element-388" data-mp="3ahd68fmx32vb">Book Your Mobile Detail Today</h2>
          <p data-id="element-389" data-mp="3ag22gfth1v47">
            Ready to experience the convenience and quality of mobile detailing
            in Ventura County? Whether you need a quick maintenance wash, a
            complete full detail, or specialty services like hybrid ceramic
            spray protection and headlight restoration, Mike's Pro Detail is ready
            to bring the shop to you. Call or text <a href="tel:8183819905" data-id="element-390" data-mp="3t7cnigcindo6">(818) 381-9905</a>{' '}
            today, or <Link to="/contact" data-id="element-391" data-mp="3oa2t0ma9sbth">request a free quote online</Link>,
            and discover why drivers throughout Camarillo, Oxnard, Ventura,
            Thousand Oaks, and all of Ventura County trust us with their
            vehicles.
          </p>
        </div>
      </div>
    </section>;
}